import { Component, OnInit, inject } from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {TranslateService} from '@ngx-translate/core';

import {CsatService, FeatureFlags, FeatureFlagService, SurvicateService} from '@core';
import {Observable} from "rxjs";

@UntilDestroy()
@Component({
    selector: 'app-csat',
    templateUrl: './csat.component.html',
    styleUrls: ['./csat.component.scss'],
    standalone: false
})
export class CsatComponent implements OnInit {
    private readonly csatService = inject(CsatService);
    private readonly translateService = inject(TranslateService);
    private readonly featureFlagService = inject(FeatureFlagService);
    private readonly survicateService = inject(SurvicateService);

    public csatScoreList = ['1', '2', '3', '4', '5'];
    public selectedCsatScore: string;
    public disableSendButton: boolean;
    public text = "";
    public helpBoxText = ['ROUTE_QUALITY', 'TIME_USAGE', 'FUNCTIONALITY', 'USER_EXPERIENCE', 'ERROR_MESSAGES', 'COMPLEXITY', 'DEFECTS_IN_PROFIL', 'UPDATING_DATA'];
    public reportIssueEnabled: Observable<boolean>;
    ngOnInit(): void {
        this.disableSendButton = true;
        this.reportIssueEnabled = this.featureFlagService.isEnabled(FeatureFlags.ReportIssueTab);
    }

    public selectCsatScore(score: string) {
        if (score === this.selectedCsatScore) {
            this.selectedCsatScore = undefined;
            this.disableSendButton = true;
        } else {
            this.selectedCsatScore = score;
            this.disableSendButton = false;
        }
    }

    public sendCsat() {
        if (this.selectedCsatScore !== undefined) {
            this.survicateService.submitCsatResponse(this.selectedCsatScore, this.text);
            this.dismissModal();
        }
    }

    public dismissModal() {
        this.csatService.enableCsat(false);
    }

    public addTextToTextArea(text) {
        const index = this.helpBoxText.indexOf(text);
        this.helpBoxText.splice(index, 1);
        this.text +=`${this.translateService.instant(text)}, `;
    }
}
